module.exports = __webpack_public_path__ + "img/1536472526.60977bf3.jpg";